import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BonusGuestView from '@/components/bonus/BonusGuestView';
import BonusLoggedInView from '@/components/bonus/BonusLoggedInView';
import styles from './Bonus.module.css';

/**
 * Bonus Page Component
 * Shows bonus information for both logged-in and non-logged-in users
 */
const Bonus = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [searchParams] = useSearchParams();
  const redeemCode = searchParams.get('code');

  // Check login status
  useEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token);
    };

    checkAuthStatus();
    window.addEventListener('storage', checkAuthStatus);
    return () => window.removeEventListener('storage', checkAuthStatus);
  }, []);

  return (
    <div className={styles.container}>
      {isLoggedIn ? (
        <BonusLoggedInView />
      ) : (
        <BonusGuestView />
      )}
    </div>
  );
};

export default Bonus;
